// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { locationGoogleMapStyles } from "@stoneage/Overrides/Components/LocationGoogleMap";
import { css } from "styled-components";

locationGoogleMapStyles.currentLocationInfoWindow = {
    options: {
        pixelOffset: {
            height: -30,
            width: 0,
            equals: () => true,
        },
    },
};

locationGoogleMapStyles.locationInfoWindow = {
    options: {
        pixelOffset: {
            height: -30,
            width: 0,
            equals: () => true,
        },
    },
};

locationGoogleMapStyles.selectedLocationAddressDisplay = {
    wrapper: {
        css: css`
            margin-top: 12px;
            font-style: normal;
        `,
    },
};
